module.exports = __webpack_public_path__ + "img/bg_kv_3_white.d1041593.svg";